// Popup: erscheint, bis der Besucher es einmal schliesst oder dem Link
// folgt. Ob es schon weggeklickt wurde, merkt sich der Browser.
// Sichtbar macht es die Klasse "ist-sichtbar" (rsce_popup.scss).

const popups = document.querySelectorAll('.ce_rsce_popup');

const schonGesehen = () => {
    try {
        return !!localStorage.getItem('popup');
    } catch (e) {
        // Speicher gesperrt (privater Modus): lieber gar nicht zeigen
        return true;
    }
};

const merken = () => {
    try {
        localStorage.setItem('popup', 'false');
    } catch (e) {
        // nichts zu tun
    }
};

popups.forEach((popup) => {
    popup.classList.toggle('ist-sichtbar', !schonGesehen());

    const schliessen = () => {
        popup.classList.remove('ist-sichtbar');
        merken();
    };

    popup.querySelectorAll('.close, .button').forEach((knopf) => {
        knopf.addEventListener('click', schliessen);
    });
});
